import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Headbar = _resolveComponent("Headbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_modal_prompt = _resolveComponent("modal-prompt")!
  const _component_modal_confirm = _resolveComponent("modal-confirm")!
  const _component_n_loading_bar_provider = _resolveComponent("n-loading-bar-provider")!
  const _component_n_notification_provider = _resolveComponent("n-notification-provider")!
  const _component_n_config_provider = _resolveComponent("n-config-provider")!

  return (_openBlock(), _createBlock(_component_n_config_provider, {
    "theme-overrides": _ctx.themeOverride,
    class: "h-100",
    style: {"padding-top":"60px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_notification_provider, { max: 10 }, {
        default: _withCtx(() => [
          _createVNode(_component_n_loading_bar_provider, null, {
            default: _withCtx(() => [
              (_ctx.showHeadbar)
                ? (_openBlock(), _createBlock(_component_Headbar, { key: 0 }))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_router_view),
              _createVNode(_component_Footer),
              _createVNode(_component_modal_prompt),
              _createVNode(_component_modal_confirm)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["theme-overrides"]))
}